import React from 'react'

interface LogoutLinkWrapperProps {
  children: React.ReactNode
}

export const LogoutLinkWrapper = (props: LogoutLinkWrapperProps) => {
  return <a href='/logout'>{props.children}</a>
}
